let search_btn = document.querySelector('.search-action.mobile\\:hidden');
if (window.innerWidth < 768) {
  search_btn = document.querySelector('.search-action.desktop\\:hidden');
}

if (search_btn) {
  search_btn.addEventListener('click', function () {
    
    setTimeout(() => {
      let wiz_search = document.querySelector('.search-input');
      if (wiz_search) {
        wiz_search.click();
      }
      
      // setTimeout(() => {
        const drawer = document.querySelector(".search-modal__content");
        const wizzyWrapper = document.querySelector(".wizzy-body-end-wrapper");
        if (drawer && wizzyWrapper) {
          drawer.appendChild(wizzyWrapper); 
        }
      // }, 1000);
    }, 500);
  });
}

window.onWizzyScriptLoaded = function () {
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT,
    function (data) {
      
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: '.search-modal [name=\"q\"]',
        type: "search",
      };
      window.wizzyConfig.search.configs.pagination.appendInExistingList = "true";
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = "true";
      window.wizzyConfig.search.configs.facets.leftFacets.mobileCollapsible = "true";
      window.wizzyConfig.filters.configs.layout = 'v1';
      window.wizzyConfig.store.currency.symbol = "Rs. ";
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_INIT,
    function (data) {
      
      window.wizzyConfig.common.lazyDOMConfig.searchInputIdentifiers[0] = {
        dom: '.search-modal [name=\"q\"]',
        type: "search",
      };
      window.wizzyConfig.search.configs.pagination.appendInExistingList = "true";
      window.wizzyConfig.filters.configs.keepOpenedInMobileAfterApply = "true";
      window.wizzyConfig.search.configs.facets.leftFacets.mobileCollapsible = "true";
      window.wizzyConfig.filters.configs.layout = 'v1';
      window.wizzyConfig.store.currency.symbol = "Rs. ";
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED,
    function (data) {
      data.minQueryLength = 1;
      return data;
    }
  );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED,
    function (data) {
      data.minQueryLength = 1;
      const closeBtn = document.querySelector(".predictive-search__close-modal-button");
      if(closeBtn) {
        closeBtn.click();
      }
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED,
    function (data) {
      return data;
    }
  );

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED,
    function (products) {

      return products;
    }
  );
  
  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, 
    function (payload) {

      if(payload.data.api === "search" || (payload.data.api === "filter" && payload.data.response.payload.filters.type === "DEFAULT")) {
        //code for setting product grid
        const gridOptions = document.querySelectorAll('.column-options__option-input');
        const productGrid = document.querySelector('.wizzy-search-results-list.product-grid');

        if (!gridOptions.length || !productGrid) return;

        gridOptions.forEach(option => {
          option.addEventListener('change', (e) => {
            if (e.target.checked) {
              // Update product grid attribute
              const newView = e.target.value;
              productGrid.setAttribute('product-grid-view', newView);

              // Remove 'checked' attribute from all other inputs
              gridOptions.forEach(input => input.removeAttribute('checked'));

              // Add 'checked' attribute to the currently selected input
              e.target.setAttribute('checked', 'checked');
            }
          });
        });

        if (window.innerWidth < 768) {
          // code to add sort by option inside filter pannel
          var sourceElement = document.querySelector(".wizzy-search-sort-wrapper");
          if (sourceElement) {
            var clonedContent = sourceElement.cloneNode(true);
            
            var columnOptions = clonedContent.querySelector(".column-options-wrapper");
            if (columnOptions) {columnOptions.remove();}
            
            var targetDiv = document.querySelector(".wizzy-sort-wrapper-in-filter");
            if(targetDiv && !targetDiv.querySelector(".wizzy-search-sort-wrapper")){
              const columnOptions = sourceElement.querySelector(".column-options-wrapper");
              targetDiv.appendChild(clonedContent);
            }
          }

          var sortInFilter = document.querySelector(".wizzy-search-filters-left-wrapper .wizzy-common-select-selector");
          sortInFilter && !sortInFilter.classList.contains("click-listener-attached") && (sortInFilter.addEventListener("click", function (event) {
            event.preventDefault(),
              event.stopPropagation(); 
            var sortOptions = document.querySelector(".wizzy-sort-wrapper-in-filter .wizzy-common-select-options");
            sortOptions && (sortOptions.style.display === "none" || sortOptions.style.display === "" ? sortOptions.style.display = "grid" : sortOptions.style.display = "none")
          }),
            sortInFilter.classList.add("click-listener-attached"))
        }

      }
    return payload;
  });

  window.wizzyConfig.events.registerEvent(
    window.wizzyConfig.events.allowedEvents.AFTER_WIZZY_API_RESPONDED,
    function (data) {
      return data;
    }
  );
};
